import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';

import * as commentsActions from '../../../redux/comments/actions';
import { formatter } from '../../../utils';
import Spin from '../../../components/loading';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';
import styles from './styles.scss';

const EditResponseModal = props => {
  const [message, setMessage] = useState(props.commentText);
  const [messageInputError, setMessageInputError] = useState();

  useEffect(() => {
    props.actions.clearForm();
  }, []);

  const onSubmit = e => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const standardMessage = formatter.toStandard(message);

    props.actions.editResponse(props.commentId, standardMessage).then(() => {
      AlertAndConfirmation({
        title: locales('titles.insertedSuccessfully'),
        text: '',
        type: 'success'
      });
      props.close();
    });
  };

  const onClose = e => {
    e.preventDefault();

    props.close();
  };

  const onChangeMessage = e => {
    const val = e.target.value;

    if (!val || val.length <= 512) {
      setMessage(val);
      setMessageInputError('');
    }
  };

  const validateForm = () => {
    let isFormValid = true;

    const standardMessage = formatter.toStandard(message);
    if (!standardMessage) {
      isFormValid = false;
      const message = locales('messages.fieldValueIsRequired', {
        fieldName: locales('fields.reply.text')
      });
      setMessageInputError(message);
    }

    return isFormValid;
  };

  return (
    <Modal size="lg" isOpen={props.isOpen}>
      <ModalHeader>
        <h4>{locales('labels.editComment')}</h4>
        <a
          href="#"
          title={locales('labels.close.modal')}
          className={styles.modalClose}
          onClick={onClose}
          disabled={props.loading}
        >
          close
        </a>
      </ModalHeader>
      <ModalBody>
        <Spin spinning={props.loading}>
          <form onSubmit={onSubmit} className="col-12">
            {props.error && (
              <div className="alert alert-danger" role="alert">
                {locales('messages.server.error')}
              </div>
            )}
            {props.failed && (
              <div className="alert alert-danger" role="alert">
                {props.failedMessage}
              </div>
            )}
            <div className="form-group">
              <label htmlFor="replyText" className="form-label">
                {locales('fields.reply.text')}
              </label>
              <textarea
                id="replyText"
                value={message}
                onChange={onChangeMessage}
                className={`form-control ${styles.replyText} ${
                  !!messageInputError ? 'is-invalid' : ''
                }`}
                maxLength="512"
                rows="8"
              />
              <small className="form-text text-muted">
                {locales('messages.reply.text.help.text')}
              </small>
              <div className="invalid-feedback">{messageInputError}</div>
            </div>
          </form>
        </Spin>
      </ModalBody>
      <ModalFooter>
        <button
          type="submit"
          className="btn btn-success"
          onClick={onSubmit}
          disabled={props.loading}
        >
          <i className="fa fa-save"></i>
          {locales('labels.save')}
        </button>
        <button className="btn btn-secondary mx-1" onClick={onClose} disabled={props.loading}>
          <i className="fa fa-times"></i>
          {locales('labels.close.modal')}
        </button>
      </ModalFooter>
    </Modal>
  );
};

EditResponseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  commentText: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  editResponse: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  return {
    loading: state.commentsReducer.editResponseLoading,
    failed: state.commentsReducer.editResponseFailed,
    error: state.commentsReducer.editResponseError,
    failedMessage: state.commentsReducer.editResponseMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      editResponse: (id, message) => dispatch(commentsActions.editResponse(id, message)),
      clearForm: () => dispatch(commentsActions.clearEditResponseComment())
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditResponseModal);
